import styled from "styled-components";

export const Container = styled.div`
  width: ${({ noContainer }) => (noContainer ? "100%" : "95%")};
  margin: ${({ noContainer }) => (noContainer ? "auto" : "2.5% auto")};
  padding: 0;

  .no-padding {
    padding: 0;
  }
`;

export const SectionPatternPolka = styled.div`
  background-color: ${({ bk }) => (bk ? bk : "#fbfbfb")};
  opacity: ${({ opacity }) => (opacity ? opacity : "0.8")}};
  background-image: radial-gradient(
    ${({ color2, theme }) => (color2 ? color2 : theme.colors.primary)} 0.65px,
    ${({ bk }) => (bk ? bk : "#fbfbfb")} 0.65px
  );
  background-size: 13px 13px;
  width: 100%;
`;
